import { useGlobalAlerts } from '@/hooks/useGlobalAlerts';

/** Mount once at app root — wires sound + toast to every user's notifications stream. */
export default function GlobalAlerts() {
  useGlobalAlerts();
  return null;
}
